import { SvgIcon, SvgIconProps } from "@commonlibs";
import clsx from "clsx";

export default function EditIcon({ className, ...rest }: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...rest} data-testid="EditIcon" className={clsx(undefined, "Icon", className)} fill="none">
            <g id="Grupo_444" transform="translate(-3.25 -1.25)">
                <path
                    id="Trazado_6103"
                    d="M18,5,15.586,2.586A2,2,0,0,0,14.172,2H6A2,2,0,0,0,4,4V20a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2"
                    fill="none"
                    stroke="#a7a7a7"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
                <path
                    id="Trazado_6104"
                    d="M21.378,12.626a2.124,2.124,0,0,0-3-3l-4.01,4.012a2,2,0,0,0-.506.854l-.837,2.87a.5.5,0,0,0,.62.62l2.87-.837a2,2,0,0,0,.854-.506Z"
                    fill="none"
                    stroke="#a7a7a7"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
                <path
                    id="Trazado_6105"
                    d="M8,18H9"
                    fill="none"
                    stroke="#a7a7a7"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
            </g>
        </SvgIcon>
    );
}
